import { useState } from 'react';
import { useSelector } from 'react-redux';
import FormBuilderSummary from 'components/formbuilder/FormBuilderSummary';
import AdminFormalityResponsePanel from './AdminFormalityResponsePanel';
import { debug } from 'utils';


export default function AdminFormalityRightColumn({
  template,
  request,
  schema,
  onFileClick,
  onDownloadDocuments,
  onResponseDocumentsChanged,
}) {
  const user = useSelector(state => state.user);
  const [activeTab, setActiveTab] = useState('request'); // request | response
  const [responseFiles, setResponseFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const isReadOnly = request.frAssignedTo === '';





  return (
    <div className="afr-summary d-flex flex-column">

      {/* TABS */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            type="button"
            className={`small py-2 nav-link ${activeTab === 'request' ? 'active' : ''}`}
            onClick={() => setActiveTab('request')}
          >
            Demande
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`small py-2 nav-link ${activeTab === 'response' ? 'active' : ''}`}
            onClick={() => setActiveTab('response')}
          >
            Réponse
          </button>
        </li>
        {user?.id === 'user56519edd43c76' &&
          <li className="nav-item">
            <button
              type="button"
              className={`small py-2 nav-link ${activeTab === 'debug' ? 'active' : ''}`}
              onClick={() => setActiveTab('debug')}
              disabled={request.frAssignedTo === ''}
            >
              Debug
            </button>
          </li>
        }
      </ul>

      {/* CONTENT */}
      <div className="flex-grow-1 border afr-request-data">
        {activeTab === 'request' && (
          <>
            {request?.template?.format?.schema && (
              <FormBuilderSummary
                schema={request.template.format.schema}
                data={request.frData}
                onFileClick={onFileClick}
                analysis={request.frAnalysis}
                readOnly={isReadOnly}
              />
            )}
            <div className="py-3 text-center">
              <button
                className="btn btn-primary"
                onClick={onDownloadDocuments}
              >
                Télécharger les fichiers joints
              </button>
            </div>
          </>
        )}

        {activeTab === 'response' && (
          <AdminFormalityResponsePanel request={request} onResponseDocumentsChanged={onResponseDocumentsChanged} />
        )}

        {activeTab === 'debug' && (
          <div className="p-3 text-muted small">
            {debug(request)}
          </div>
        )}
      </div>


    </div>
  );
}
